// Auto-generated by `rake web:generate`. Do not edit manually.
export const GENERATED_RUNNER_PRESETS = Object.freeze({
  "cpu": {
    "id": "cpu",
    "label": "CPU (examples/8bit/hdl/cpu)",
    "simIrPath": "./assets/fixtures/cpu/ir/cpu_lib_hdl.json",
    "explorerIrPath": "./assets/fixtures/cpu/ir/cpu_hier.json",
    "sourceBundlePath": "./assets/fixtures/cpu/ir/cpu_sources.json",
    "schematicPath": "./assets/fixtures/cpu/ir/cpu_schematic.json",
    "preferredTab": "ioTab",
    "traceEnabledOnLoad": false,
    "preferredBackend": "compiler",
    "compilerWasmPath": "./assets/pkg/ir_compiler_cpu.wasm",
    "enableApple2Ui": false,
    "usesManualIr": false,
    "defaultBin": {
      "path": "./assets/fixtures/cpu/software/conway_glider_80x24.bin",
      "offset": 0,
      "space": "main",
      "startPc": 32,
      "resetAfterLoad": true
    },
    "timing": {
      "cyclesPerHertz": 1,
      "hertzLabel": "CPU"
    },
    "io": {
      "enabled": true,
      "api": "generic",
      "memory": {
        "dumpStart": 0,
        "dumpLength": 768,
        "addressSpace": 65536,
        "viewMapped": true,
        "dumpReadMapped": true,
        "directWriteMapped": true
      },
      "display": {
        "enabled": true,
        "mode": "cpu8bit_text",
        "text": {
          "start": 2048,
          "width": 80,
          "height": 24,
          "rowStride": 80,
          "rowLayout": "linear",
          "charMask": 255,
          "asciiMin": 32,
          "asciiMax": 126
        }
      },
      "keyboard": {
        "enabled": true,
        "mode": "memory_mapped",
        "dataAddr": 254,
        "strobeAddr": 255,
        "strobeValue": 1,
        "strobeClearValue": 0,
        "upperCase": true,
        "setHighBit": false,
        "enterCode": 13,
        "backspaceCode": 8
      },
      "pcSignalCandidates": [
        "pc_out"
      ],
      "watchSignals": [
        "pc_out",
        "acc_out",
        "sp_out",
        "state_out",
        "zero_flag_out",
        "mem_addr",
        "mem_read_en",
        "mem_write_en",
        "halted"
      ]
    },
    "defaults": {
      "stepTicks": 100,
      "runBatch": 2000,
      "uiUpdateCycles": 2000
    }
  },
  "mos6502": {
    "id": "mos6502",
    "label": "MOS 6502 CPU Runner",
    "simIrPath": "./assets/fixtures/mos6502/ir/mos6502.json",
    "explorerIrPath": "./assets/fixtures/mos6502/ir/mos6502_hier.json",
    "sourceBundlePath": "./assets/fixtures/mos6502/ir/mos6502_sources.json",
    "schematicPath": "./assets/fixtures/mos6502/ir/mos6502_schematic.json",
    "traceEnabledOnLoad": false,
    "preferredBackend": "compiler",
    "compilerWasmPath": "./assets/pkg/ir_compiler_mos6502.wasm",
    "preferredTab": "ioTab",
    "enableApple2Ui": false,
    "usesManualIr": false,
    "defaultBin": {
      "path": "./assets/fixtures/mos6502/memory/karateka_mem.rhdlsnap",
      "offset": 0,
      "space": "main",
      "resetAfterLoad": true
    },
    "timing": {
      "cyclesPerHertz": 1,
      "hertzLabel": "6502"
    },
    "io": {
      "enabled": true,
      "api": "generic",
      "memory": {
        "dumpStart": 0,
        "dumpLength": 768,
        "addressSpace": 65536,
        "viewMapped": true,
        "dumpReadMapped": true,
        "directWriteMapped": true
      },
      "display": {
        "enabled": true,
        "mode": "apple2",
        "text": {
          "start": 1024,
          "width": 40,
          "height": 24,
          "rowStride": 128,
          "rowLayout": "apple2",
          "charMask": 127,
          "asciiMin": 32,
          "asciiMax": 126
        }
      },
      "keyboard": {
        "enabled": true,
        "mode": "apple2"
      },
      "watchSignals": [
        "pc_debug",
        "opcode_debug",
        "a_debug",
        "x_debug",
        "y_debug",
        "s_debug",
        "p_debug",
        "speaker"
      ]
    }
  },
  "apple2": {
    "id": "apple2",
    "label": "Apple II System Runner",
    "simIrPath": "./assets/fixtures/apple2/ir/apple2.json",
    "explorerIrPath": "./assets/fixtures/apple2/ir/apple2_hier.json",
    "sourceBundlePath": "./assets/fixtures/apple2/ir/apple2_sources.json",
    "schematicPath": "./assets/fixtures/apple2/ir/apple2_schematic.json",
    "romPath": "./assets/fixtures/apple2/memory/appleiigo.rom",
    "preferredTab": "ioTab",
    "traceEnabledOnLoad": false,
    "preferredBackend": "compiler",
    "arcilatorWasmPath": "./assets/pkg/apple2_arcilator.wasm",
    "verilatorWasmPath": "./assets/pkg/apple2_verilator.wasm",
    "enableApple2Ui": true,
    "usesManualIr": false,
    "autoLoadOnBoot": true,
    "defaultBin": {
      "path": "./assets/fixtures/apple2/memory/karateka_mem.bin",
      "offset": 0,
      "space": "main",
      "startPc": "0xB82A",
      "resetAfterLoad": true
    },
    "timing": {
      "cyclesPerHertz": 1,
      "hertzLabel": "6502"
    },
    "io": {
      "enabled": true,
      "api": "apple2",
      "memory": {
        "dumpStart": 0,
        "dumpLength": 768,
        "addressSpace": 65536,
        "viewMapped": true,
        "dumpReadMapped": false,
        "directWriteMapped": false
      },
      "display": {
        "enabled": true,
        "mode": "apple2"
      },
      "keyboard": {
        "enabled": true,
        "mode": "apple2_special"
      },
      "sound": {
        "enabled": true,
        "mode": "apple2_special"
      }
    },
    "defaults": {
      "displayHires": true,
      "displayColor": true,
      "memoryFollowPc": true
    }
  },
  "gameboy": {
    "id": "gameboy",
    "label": "Game Boy System Runner",
    "simIrPath": "./assets/fixtures/gameboy/ir/gameboy.json",
    "explorerIrPath": "./assets/fixtures/gameboy/ir/gameboy_hier.json",
    "sourceBundlePath": "./assets/fixtures/gameboy/ir/gameboy_sources.json",
    "schematicPath": "./assets/fixtures/gameboy/ir/gameboy_schematic.json",
    "preferredTab": "ioTab",
    "traceEnabledOnLoad": false,
    "preferredBackend": "compiler",
    "compilerWasmPath": "./assets/pkg/ir_compiler_gameboy.wasm",
    "enableApple2Ui": false,
    "usesManualIr": false,
    "defaultBin": {
      "path": "./assets/fixtures/gameboy/roms/dmg_boot.bin",
      "offset": 0,
      "space": "boot_rom",
      "resetAfterLoad": true
    },
    "timing": {
      "cyclesPerHertz": 1,
      "hertzLabel": "SM83"
    },
    "io": {
      "enabled": false,
      "api": "generic",
      "memory": {
        "dumpStart": 0,
        "dumpLength": 768,
        "addressSpace": 65536,
        "viewMapped": true,
        "dumpReadMapped": true,
        "directWriteMapped": true
      }
    }
  },
  "riscv": {
    "id": "riscv",
    "label": "RISC-V xv6 Runner",
    "simIrPath": "./assets/fixtures/riscv/ir/riscv.json",
    "explorerIrPath": "./assets/fixtures/riscv/ir/riscv_hier.json",
    "sourceBundlePath": "./assets/fixtures/riscv/ir/riscv_sources.json",
    "schematicPath": "./assets/fixtures/riscv/ir/riscv_schematic.json",
    "preferredTab": "ioTab",
    "traceEnabledOnLoad": false,
    "enableApple2Ui": false,
    "usesManualIr": false,
    "defaultBin": {
      "path": "./assets/fixtures/riscv/software/bin/xv6_kernel.bin",
      "offset": 2147483648,
      "space": "main",
      "startPc": "0x80000000",
      "fastBoot": "aggressive",
      "resetAfterLoad": true
    },
    "defaultSrcmap": {
      "path": "./assets/fixtures/riscv/software/bin/xv6_kernel_srcmap.json"
    },
    "defaultDisk": {
      "path": "./assets/fixtures/riscv/software/bin/xv6_fs.img",
      "offset": 0
    },
    "timing": {
      "cyclesPerHertz": 1,
      "hertzLabel": "RISC-V"
    },
    "defaults": {
      "memoryFollowPc": false
    },
    "preferredBackend": "compiler",
    "compilerWasmPath": "./assets/pkg/ir_compiler_riscv.wasm",
    "arcilatorWasmPath": "./assets/pkg/riscv_arcilator.wasm",
    "verilatorWasmPath": "./assets/pkg/riscv_verilator.wasm",
    "io": {
      "enabled": true,
      "api": "generic",
      "memory": {
        "dumpStart": 2147483648,
        "dumpLength": 768,
        "addressSpace": 4294967296,
        "viewMapped": true,
        "dumpReadMapped": true,
        "directWriteMapped": true
      },
      "display": {
        "enabled": true,
        "mode": "uart",
        "text": {
          "start": 0,
          "width": 80,
          "height": 24,
          "rowStride": 80,
          "rowLayout": "linear",
          "charMask": 255,
          "asciiMin": 32,
          "asciiMax": 126
        }
      },
      "keyboard": {
        "enabled": true,
        "mode": "uart"
      },
      "pcSignalCandidates": [
        "debug_pc"
      ],
      "watchSignals": [
        "debug_pc",
        "debug_inst",
        "debug_x1",
        "debug_x2",
        "debug_x10",
        "debug_x11"
      ]
    }
  },
  "riscv_linux": {
    "id": "riscv_linux",
    "label": "RISC-V Linux Runner",
    "simIrPath": "./assets/fixtures/riscv_linux/ir/riscv_linux.json",
    "explorerIrPath": "./assets/fixtures/riscv_linux/ir/riscv_linux_hier.json",
    "sourceBundlePath": "./assets/fixtures/riscv_linux/ir/riscv_linux_sources.json",
    "schematicPath": "./assets/fixtures/riscv_linux/ir/riscv_linux_schematic.json",
    "preferredTab": "ioTab",
    "traceEnabledOnLoad": false,
    "enableApple2Ui": false,
    "usesManualIr": false,
    "defaultSrcmap": {
      "path": "./assets/fixtures/riscv/software/bin/linux_kernel_srcmap.json"
    },
    "defaultAssets": [
      {
        "kind": "main",
        "path": "./assets/fixtures/riscv/software/bin/linux_kernel.bin",
        "offset": "0x80400000"
      },
      {
        "kind": "main",
        "path": "./assets/fixtures/riscv/software/bin/linux_initramfs.cpio",
        "offset": "0x84000000"
      },
      {
        "kind": "main",
        "path": "./assets/fixtures/riscv/software/bin/linux_virt.dtb",
        "offset": "0x87f00000"
      },
      {
        "kind": "main",
        "path": "./assets/fixtures/riscv/software/bin/linux_bootstrap.bin",
        "offset": "0x803ff000",
        "startPc": "0x803ff000",
        "resetAfterLoad": true
      }
    ],
    "timing": {
      "cyclesPerHertz": 1,
      "hertzLabel": "RISC-V Linux"
    },
    "defaults": {
      "memoryFollowPc": false
    },
    "preferredBackend": "compiler",
    "compilerWasmPath": "./assets/pkg/ir_compiler_riscv.wasm",
    "arcilatorWasmPath": "./assets/pkg/riscv_arcilator.wasm",
    "verilatorWasmPath": "./assets/pkg/riscv_verilator.wasm",
    "io": {
      "enabled": true,
      "api": "generic",
      "memory": {
        "dumpStart": 2147483648,
        "dumpLength": 768,
        "addressSpace": 4294967296,
        "viewMapped": true,
        "dumpReadMapped": true,
        "directWriteMapped": true
      },
      "display": {
        "enabled": true,
        "mode": "uart",
        "text": {
          "start": 0,
          "width": 80,
          "height": 24,
          "rowStride": 80,
          "rowLayout": "linear",
          "charMask": 255,
          "asciiMin": 32,
          "asciiMax": 126
        }
      },
      "keyboard": {
        "enabled": true,
        "mode": "uart"
      },
      "pcSignalCandidates": [
        "debug_pc"
      ],
      "watchSignals": [
        "debug_pc",
        "debug_inst",
        "debug_x1",
        "debug_x2",
        "debug_x10",
        "debug_x11"
      ]
    }
  }
});
export const GENERATED_RUNNER_ORDER = Object.freeze(["cpu","mos6502","apple2","gameboy","riscv","riscv_linux"]);
export const GENERATED_DEFAULT_RUNNER_ID = "apple2";
